import { render, staticRenderFns } from "./InvoiceDetailsModal.vue?vue&type=template&id=b5cbc3c6&scoped=true&"
import script from "./InvoiceDetailsModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDetailsModal.vue?vue&type=style&index=0&id=b5cbc3c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cbc3c6",
  null
  
)

component.options.__file = "InvoiceDetailsModal.vue"
export default component.exports